import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Carousel.css";
import { Link } from 'react-router-dom';

const Carousel = () => {
  const [isMobile, setIsMobile] = useState(false);

  // Desktop images
  const desktopImages = [

    {
      src: 'https://res.cloudinary.com/dd8cg94ku/image/upload/v1736764523/4_4_a3lvoa.webp',
      heading: (
        <>
          A <span className='hero-heading-color' > Luxurious </span><br/>Marriage Garden & Resort
        </>
      ),
      text: 'Create unforgettable memories at The Golden Palace, a premium destination for lavish weddings. Our stunning garden and majestic halls offer the perfect setting for your dream celebration.',
      buttonLabel: 'Book Now',
    },
    {
      src: 'https://res.cloudinary.com/dd8cg94ku/image/upload/v1739812250/1_kzca86.svg',
      heading: (
        <>
          Welcome to The  <br/>Golden <span className='hero-heading-color' >Palace</span> 
        </>
      ),
      text: 'Experience the grandeur of Rajasthan at The Golden Palace, where timeless traditions meet modern luxury. Celebrate your special moments in our exquisite marriage garden and resort.',
      buttonLabel: 'Book Now',
    },
    {
      src: 'https://res.cloudinary.com/dd8cg94ku/image/upload/v1736764533/12_swayn9.webp',
      heading: (
        <>
          Premium <br/><span className='hero-heading-color' >Accommodation</span> & Relaxation
        </>
      ),
      text: 'Indulge in comfort with our luxurious rooms and suites. Perfect for hosting your guests with top-notch hospitality and modern amenities.',
      buttonLabel: 'Book Now',
    },
    
   
    
    {
      src: 'https://res.cloudinary.com/dd8cg94ku/image/upload/v1736764528/11_k4t7fw.webp',
      heading: (
        <>
          Royal   <br/><span className='hero-heading-color' >Elegance</span> & Grandeur
        </>
      ),
      text: 'Feel the charm of royal Rajasthan with our intricately designed spaces. From regal décor to magnificent architecture, every corner reflects elegance for your special day.',
      buttonLabel: 'Book Now',
    },
  ];

  // Mobile images
  const mobileImages = [
    
    {
      src: 'https://res.cloudinary.com/dd8cg94ku/image/upload/v1736764523/4_4_a3lvoa.webp',
      heading: (
        <>
          A <span className='hero-heading-color' > Luxurious </span><br/>Marriage Garden & Resort
        </>
      ),
      text: 'Create unforgettable memories at The Golden Palace, a premium destination for lavish weddings. Our stunning garden and majestic halls offer the perfect setting for your dream celebration.',
      buttonLabel: 'Book Now',
    },
    {
      src: 'https://res.cloudinary.com/dd8cg94ku/image/upload/v1736764532/5_1_bh3ofi.webp',
      heading: (
        <>
          Welcome to The  <br/>Golden <span className='hero-heading-color' >Palace</span> 
        </>
      ),
      text: 'Experience the grandeur of Rajasthan at The Golden Palace, where timeless traditions meet modern luxury. Celebrate your special moments in our exquisite marriage garden and resort.',
      buttonLabel: 'Book Now',
    },
    {
      src: 'https://res.cloudinary.com/dd8cg94ku/image/upload/v1736773382/2_otlsth.webp',
      heading: (
        <>
          Premium <br/><span className='hero-heading-color' >Accommodation</span> & Relaxation
        </>
      ),
      text: 'Indulge in comfort with our luxurious rooms and suites. Perfect for hosting your guests with top-notch hospitality and modern amenities.',
      buttonLabel: 'Book Now',
    },
    
   
    
    {
      src: 'https://res.cloudinary.com/dd8cg94ku/image/upload/v1739858163/IMG-20250213-WA0013_tudvou.jpg',
      heading: (
        <>
          Royal   <br/><span className='hero-heading-color' >Elegance</span> & Grandeur
        </>
      ),
      text: 'Feel the charm of royal Rajasthan with our intricately designed spaces. From regal décor to magnificent architecture, every corner reflects elegance for your special day.',
      buttonLabel: 'Book Now',
    },
    
    
  ];

  // Function to handle screen size change
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Change at 768px (or adjust the breakpoint as needed)
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Call handler right away so state gets updated with initial screen size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  
  const imagesToUse = isMobile ? mobileImages : desktopImages;

  return (
    <div className="carousel-container">
     <Slider
  {...settings}
  beforeChange={(oldIndex, newIndex) => {
    const oldSlide = document.querySelector(`.slick-slide[data-index="${oldIndex}"] .carousel-text-overlay`);
    const newSlide = document.querySelector(`.slick-slide[data-index="${newIndex}"] .carousel-text-overlay`);

    if (oldSlide) {
      oldSlide.style.animation = "fadeOut 1s ease forwards";
    }
    if (newSlide) {
      newSlide.style.animation = "fadeIn 1s ease forwards";
    }
  }}
>
  {imagesToUse.map((image, index) => (
    <div key={index} className="carousel-slide">
      <div className="carousel-overlay"></div>
      <img src={image.src} alt={`Slide ${index}`} />
      <div className="carousel-text-overlay">
        <h2>{image.heading}</h2>
        <p>{image.text}</p>
       <Link to="/popupcontactt"><button className="carousel-button">{image.buttonLabel}</button></Link> 
      </div>
    </div>
  ))}
</Slider>

    </div>
  );
};

export default Carousel;
